import { registerCondition } from 'core/forms';

import isHtmlEditorChecked from './isHtmlEditorChecked';

const isHtmlEditorUnchecked = ({ model }) => ({
  condition: null,
  hasCondition: !isHtmlEditorChecked({ model }).hasCondition,
});

registerCondition('isHtmlEditorUnchecked', isHtmlEditorUnchecked);

export default isHtmlEditorUnchecked;
